// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'

// Import your components
import LandingPage from '@/components/LandingPage.vue'
import Contact from '@/components/Contact.vue'
import About from '@/components/About.vue'
import Works from '@/components/Works.vue'

const routes = [
  { path: '/', name: 'LandingPage', component: LandingPage },
  { path: '/about', name: 'About', component: About },
  { path: '/contact', name: 'Contact', component: Contact },
  { path: '/works', name: 'Works', component: Works },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

export default router
